import { addCyPrefixToIDs } from 'moet-test-utils/cypress/utils';
import { PAYMENT_INTERVAL } from '@/constants';

const cyPrefix = 'containers_first_pre_assessment_container';

let ids = {
  INPUT_YEARLY_ACQUIRED_VOLUME: 'INPUT_YEARLY_ACQUIRED_VOLUME',
  PAYMENT_DELAY: 'PAYMENT_DELAY',
  PAYMENT_INTERVAL: 'PAYMENT_INTERVAL',
  VOLUME_BY_CARD: 'VOLUME_BY_CARD',
  BTN_BACK: 'BTN_BACK',
  BTN_SUBMIT: 'BTN_SUBMIT',
};
ids = addCyPrefixToIDs(cyPrefix, ids);

export const CY_UNDERWRITING_INFO_CONTAINER_IDS = ids;

export const tPrefix = 'products-fe.containers.underwriting_info';

export const PAYMENT_DELAY_LIMITS = {
  [PAYMENT_INTERVAL.DAILY]: { min: 0, max: 21 },
  [PAYMENT_INTERVAL.WEEKLY]: { min: 0, max: 6 },
};
